var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('fullscreen-menu'),_vm._v(" "),_c('menu-bar'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('client-only',[_c('cookie-banner')],1),_vm._v(" "),_c('big-footer',{attrs:{"border":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }